import React from 'react';
import '../css/logoutPopUp.css'; // Adjust your file path if needed
import YourImage from '../images/logout-icon.png'; // Add your image path here

export default function ConfirmLogoutModal({ isOpen, onClose, onConfirm }) {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay1">
            <div className="modal-content1">
                {/* Image at the top */}
                <img src={YourImage} alt="Your Image" className="modal-top-image" />
                <h3 className='h3LogoutText'>Are you sure you want to log out?</h3>
                <div className="modal-actions1">
                    <button className="btn-confirm1" onClick={onConfirm}>Yes</button>
                    <button className="btn-cancel1" onClick={onClose}>No</button>
                </div>
            </div>
        </div>
    );
}
